// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingHeader_root__jdOo9","logo":"LandingHeader_logo__NzYj4"};